import { Box, styled, Tooltip } from "@mui/material";
import { ColumnsPanelTrigger, DataGridPro, DataGridProProps, Toolbar, ToolbarButton } from "@mui/x-data-grid-pro";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { useContext, useMemo } from "react";
import { AppContext } from "../../../../../../common/contexts/app_context/app_context";
import { useColumnSelectionConfig } from "../../../../../../common/hooks/use_column_selection_config";

/* ================= Toolbar ================= */

const CustomToolbar = () => (
  <Toolbar>
    <Tooltip title="Colunas">
      <ColumnsPanelTrigger render={<ToolbarButton />}>
        <ViewColumnIcon fontSize="small" />
      </ColumnsPanelTrigger>
    </Tooltip>
  </Toolbar>
);

/* ================= Props ================= */

interface Props extends DataGridProProps {
  tableName: string;
  height?: string;
  maxHeight?: string;
  collapsed?: boolean;
  maxWidth?: string;
}

/* ================= Grid ================= */

export const StyledDataGridTreePermissoes = ({ tableName, height = "60vh", disableRowSelectionExcludeModel = true, maxWidth = '100%', maxHeight, collapsed = false, rows, columns, ...props }: Props) => {
  const { theme: mode } = useContext(AppContext);

  const [columnsVisibilityModel, handleColumnsVisibilityModel] = useColumnSelectionConfig({
    tabela: tableName,
  });

  const Grid = useMemo(
    () =>
      styled(DataGridPro)(() => ({
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: "#aeeece",
        },
        "& .MuiDataGrid-footerContainer": {
          display: "none",
        },
        "& .MuiIconButton-root": {
          color: "black",
        },
        backgroundColor: mode === "dark" ? "#2C2C2C" : "#FFFFFF",
      })),
    [mode]
  );

  return (
    <Box sx={{ height, width: "100%", maxHeight, maxWidth }}>
      <Grid
        rows={rows}
        columns={columns}
        treeData
        getTreeDataPath={(row: any) => row.path}
        defaultGroupingExpansionDepth={collapsed ? 0 : -1}
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        columnVisibilityModel={columnsVisibilityModel}
        disableRowSelectionExcludeModel={disableRowSelectionExcludeModel}
        onColumnVisibilityModelChange={handleColumnsVisibilityModel}
        disableColumnSorting
        disableRowSelectionOnClick
        localeText={{
          noRowsLabel: "Não existem itens para mostrar!",
        }}
        {...props}
      />
    </Box>
  );
};
